const styles = {
  select: {
    backgroundColor: "white",
  },
};
export default styles;
